








import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class NewBackPage extends Vue {
  backLink = '';
  tips = '';
  status: string = 'success';

  get statusIcon() {
    const iconMap = {
      success: require('../../stylesheets/images/success-status.png'),
      warn: require('../../stylesheets/images/warn-status.png'),
      time: require('../../stylesheets/images/time-status.png')
    }
    // @ts-ignore
    return iconMap[this.status as string] || iconMap.success
  }

  created() {
    const { query } = this.$route
    const { status, tips, backLink, title } = query
    document.title = title as string
    this.backLink = backLink as string
    this.status = status as string
    this.tips = tips as string
  }

  handleToBack() {
    if (!this.backLink) return
    this.$router.push({
      path: this.backLink
    })
  }
}
